import { useTranslation } from 'react-i18next'
import { Input } from '@/components/shadcn/input'
import type { PropertyEditorProps } from '@/lib/action-modules/registry/subtypes/types'

// The old portal opened a service-module picker dialog here. That picker isn't part of this
// editor's scope yet, so we bind the module id directly (still a faithful value round-trip).
// TODO: replace with a proper service-module select once that shared component exists.
export default function ServiceModuleIdEditor(props: PropertyEditorProps) {
  const { t } = useTranslation('action-modules-wizard')
  const value = props.value
  return (
    <Input
      type="number"
      placeholder={t('subtypes.base.serviceModuleIdPlaceholder')}
      value={typeof value === 'number' ? value : ''}
      onChange={e => props.onChanged(e.target.value !== '' ? Number(e.target.value) : null)}
    />
  )
}
